import React from "react"
import { toast } from "react-toastify"

import Dialog from "~/ui-rtk/components/ui/common/Dialog"
import Card from "~/ui-rtk/components/ui/common/Card"
import { Button } from "~/ui-rtk/components/ui/controls"
import { H3 } from "~/ui-rtk/components/ui/typography"
import { useCompanyConnectorControllerResetSetupMutation } from "~/ui-rtk/api/companyConnectorApi"

export type ResetSetupConfirmDialogProps = {
  isOpen: boolean
  companyConnectorId: string
  connectorName: string
  onClose: () => void
  onSuccess?: () => void
}

const ResetSetupConfirmDialog: React.FC<ResetSetupConfirmDialogProps> = ({
  isOpen,
  companyConnectorId,
  connectorName,
  onClose,
  onSuccess,
}) => {
  const [resetSetup, { isLoading }] =
    useCompanyConnectorControllerResetSetupMutation()

  const handleConfirm = async () => {
    try {
      await resetSetup({ id: companyConnectorId }).unwrap()
      toast.success(`${connectorName} setup reset. You can reconnect now.`, {
        toastId: `reset-setup-success-${companyConnectorId}`,
      })
      onSuccess?.()
      onClose()
    } catch {
      toast.error(`Failed to reset ${connectorName} setup. Please try again.`, {
        toastId: `reset-setup-failed-${companyConnectorId}`,
      })
    }
  }

  return (
    <Dialog isOpen={isOpen} handleClose={onClose} width={460}>
      <Card rounded className="p-6">
        <H3 className="text-start mb-3">Start over?</H3>
        <p className="text-sm text-gray-200 text-start mb-5">
          This will delete your current {connectorName} setup progress. You'll
          need to reconnect from scratch. Continue?
        </p>
        <div className="flex justify-end gap-3">
          <Button
            variant={{ variant: "outlined" }}
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant={{ variant: "solid", color: "red" }}
            onClick={handleConfirm}
            disabled={isLoading}
            isLoading={isLoading}
          >
            Start over
          </Button>
        </div>
      </Card>
    </Dialog>
  )
}

export default ResetSetupConfirmDialog
